<div class="fd-multiple-text-container">
    <mat-form-field class="fd-input__container" color="accent">
        <div fxFlex="50">
          <input maxlength="200" (keydown.enter)="addNewItem()" matInput #inputField [(ngModel)]="novaString"  [placeholder]="placeholder" class="fd-input__field"
            autocomplete="off" tabindex="0">
        </div>
      </mat-form-field>
      <fa-icon icon='plus-circle' (click)="addNewItem()" [matTooltip]="addButtonDisabled ? 'Número máximo de registros!' : '' " [ngClass]="{'fd-multiple-text-icon-add': !addButtonDisabled, 'fd-multiple-text-icon-add-disabled': addButtonDisabled}" class="fd-multiple-text-icon" size="1x"></fa-icon>
  </div>

<div class="fd-multiple-text-container" *ngFor="let item of items; let i = index">
    <mat-form-field class="fd-input__container" color="accent">
    <div fxFlex="50">
        <input maxlength="200" matInput #inputField [value]="items[i]" (change)="onEditChange(i, $event.target.value)" class="fd-input__field"
        autocomplete="off" tabindex="0">
    </div>
    </mat-form-field>
    <fa-icon icon='minus-circle' (click)="removerString(i)" class="fd-multiple-text-icon fd-multiple-text-icon-remove" size="1x"></fa-icon>
</div>
